export default "__VITE_ASSET__Cy9F934y__"